import { render, staticRenderFns } from "./bind_card.vue?vue&type=template&id=abe5324c&scoped=true"
import script from "./bind_card.vue?vue&type=script&lang=js"
export * from "./bind_card.vue?vue&type=script&lang=js"
import style0 from "./bind_card.vue?vue&type=style&index=0&id=abe5324c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe5324c",
  null
  
)

export default component.exports